import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { IReport, ReportState } from '~/shared';
import { setActiveReportId, useLayoutDispatch } from '../../redux';
import { StaffNicknames } from '../ReportChat';
import {
	StyledAuthorInfoContainer,
	StyledBottomContainer,
	StyledContainer,
	StyledDateTimeTag,
	StyledHeadContainer,
	StyledHeadInfoContainer,
	StyledHelpTag,
	StyledPendingTag,
	StyledReportNumber,
	StyledStatusTag,
	StyledTagsContainer,
	StyledText,
} from './ReportListItem.styled';

interface IReportListItemProps {
	report: IReport;
	isStaff?: boolean;
	active?: boolean;
}

const ReportListItem = ({ report, isStaff, active }: IReportListItemProps) => {
	const dispatch = useLayoutDispatch();

	const staffNames: string[] = isStaff
		? report.viewingStaff ?? []
		: report.participants ?? [];

	const handleClick = () => {
		if (isStaff) {
			rage.reports
				.joinReport(report.id)
				.catch((err) => rage.notifications.showException(err));
		}
		dispatch(setActiveReportId(report.id));
	};

	return (
		<StyledContainer
			$isStaff={isStaff}
			$active={active}
			$invertStatus={
				report.state === ReportState.CLOSED ||
				report.state === ReportState.COMPLETED
			}
			data-report-id={report.id}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
			onClick={() => {
				handleClick();
				playSound(Sound.ClickButton);
			}}
		>
			<StyledHeadContainer>
				{isStaff && (
					<StyledHeadInfoContainer>
						<Text>Автор:</Text>
						<StyledAuthorInfoContainer $online={report.playerOnline}>
							<div className="dot"></div>
							<Text>
								{`${report.playerName ?? 'N/A'} #${
									report.accountId ?? 'N/A'
								} ID: ${report.characterId ?? 'N/A'}`}
							</Text>
						</StyledAuthorInfoContainer>
					</StyledHeadInfoContainer>
				)}
				<StyledHeadInfoContainer>
					<Text>Обращение:</Text>
					<StyledReportNumber>
						<Text>{report.id}</Text>
					</StyledReportNumber>
				</StyledHeadInfoContainer>
			</StyledHeadContainer>
			<StyledText>{report.lastMessage ?? '—'}</StyledText>
			<StyledBottomContainer>
				<StyledTagsContainer>
					{isStaff &&
						report.state === ReportState.ACTIVE &&
						report.isHelpNeeded && (
							<StyledHelpTag>
								<Text>{'Нужна помощь'}</Text>
							</StyledHelpTag>
						)}
					{isStaff &&
						report.state === ReportState.ACTIVE &&
						!report.lastMessageIsFromStaff && (
							<StyledPendingTag>
								<Text>{'Ожидание ответа'}</Text>
							</StyledPendingTag>
						)}
					{isStaff && (
						<StyledStatusTag className={report.state}>
							<Text>
								{report.state === ReportState.CLOSED && 'Закрыто'}
								{report.state === ReportState.COMPLETED && 'Завершено'}
								{report.state === ReportState.ACTIVE && 'Активное'}
							</Text>
						</StyledStatusTag>
					)}
					<StaffNicknames staffNames={staffNames} />
				</StyledTagsContainer>
				<StyledDateTimeTag>
					<Text className="date">
						{new Date(report.createdAt).toLocaleDateString('ru-RU', {
							day: '2-digit',
							month: '2-digit',
							year: '2-digit',
							timeZone: 'Europe/Moscow',
						})}
					</Text>
					<Text>
						{new Date(report.createdAt).toLocaleTimeString('ru-RU', {
							hour12: false,
							timeZone: 'Europe/Moscow',
						})}
					</Text>
				</StyledDateTimeTag>
			</StyledBottomContainer>
		</StyledContainer>
	);
};

export { ReportListItem };
